import {createPortal} from 'react-dom';
import * as styles from './GalleryLoadingOverlay.module.scss';

export const GalleryLoadingOverlay = ({show}: {show: boolean}) => {
  if (!show) return null;

  return createPortal(
    <div
      className={styles.galleryLoadingOverlay}
      role="status"
      aria-live="polite"
      aria-atomic="true"
    >
      <span className={styles.visuallyHidden}>Loading...</span>
      <div className={styles.galleryLoadingOverlayContent} aria-hidden="true" />
    </div>,
    document.body
  );
};
